/* Three customer-facing demo accounts.
 *
 * Every account uses the same password "Demo123!". Each maps to a customer
 * role so the login flow lands the user on their dashboard. The shape mirrors
 * MeResponse from frontend/src/api/hooks.ts so consumers don't see a diff vs
 * the real backend.
 */

export const DEMO_PASSWORD = "Demo123!";

export const DEMO_USERS = [
  {
    id: "u-customer",
    email: "customer@nethrasap.in",
    phone: "+91 98201 12345",
    role: "customer",
    status: "active",
    email_verified: true,
    last_login_at: null,
    profile: { full_name: "Priya Iyer", avatar_url: null, attributes: {} },
    permissions: ["catalog.view", "cart.use", "orders.self"],
  },
  {
    id: "u-clinician",
    email: "clinician@nethrasap.in",
    phone: "+91 98456 88914",
    role: "clinician",
    status: "active",
    email_verified: true,
    last_login_at: null,
    profile: { full_name: "Dr. Kavita Menon", avatar_url: null, attributes: { council_id: "KMC-72840" } },
    permissions: ["catalog.view", "cart.use", "orders.self", "pricing.institutional"],
  },
  {
    id: "u-retailer",
    email: "retailer@nethrasap.in",
    phone: "+91 98678 11420",
    role: "retailer",
    status: "active",
    email_verified: true,
    last_login_at: null,
    profile: { full_name: "Rajesh Pharmacy", avatar_url: null, attributes: { gstin: "27AABCN9012P1Z3" } },
    permissions: ["catalog.view", "cart.use", "orders.self", "pricing.wholesale", "credit.net30"],
  },
];

/** Where each role lands after login — back to the storefront. */
export const ROLE_LANDING = {
  customer: "/",
  clinician: "/",
  retailer: "/",
};
